// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { TmcColumnCount, ITmcColumnCount } from "./Reports.TmcColumnCount.gen";

export interface ITurningMovementCountV2 {
	startTime: string | undefined;

	counts: ITmcColumnCount[] | undefined;

	$type?: string | undefined;
}
export class TurningMovementCountV2 {
	constructor(data?: ITurningMovementCountV2) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.startTime) { this.startTime = new Date(data.startTime); }
		this.counts = data.counts ? data.counts.map((c: any) => new TmcColumnCount(c)) : [];
	}

	startTime: Date | undefined;

	counts: TmcColumnCount[] | undefined = [];

	static $type: string = "CoreApi.Models.Reports.TurningMovementCountV2, ";
	$type?: string | undefined = TurningMovementCountV2.$type;
}

